import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { StepBasedOnSelectboxOptions } from "../enumerations/step-based-on.enum";

@Injectable({
  providedIn: "root"
})

export class FormlyHelper {

  private generalFormSubmissionSubject: Subject<void> = new Subject();

  public generalFormSubmitted() {
    this.generalFormSubmissionSubject.next();
  }

  public getGeneralFormSubmission$(): Observable<void> {
    return this.generalFormSubmissionSubject.asObservable();
  }

  // create step with deadline
  public createStepWithDeadlineSubject: Subject<StepBasedOnSelectboxOptions> = new Subject<StepBasedOnSelectboxOptions>();

  public createStepWithDeadline(basedOn: StepBasedOnSelectboxOptions) {
    this.createStepWithDeadlineSubject.next(basedOn);
  }

  public getCreateStepWithDeadline$(): Observable<StepBasedOnSelectboxOptions> {
    return this.createStepWithDeadlineSubject.asObservable();
  }
}
